export const EMPTY_VALUE = '—';

export const DATE_COLUMN_WIDTH = '160px';
